import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Box, Stack, Typography, Button } from '@mui/material';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import AddIcon from '@mui/icons-material/Add';
import { TableV2, CustomFilterV2 } from '../../../components/v2';
import * as selectorsMalhas from '../../../store/malha/reducer';
import * as actionsMalhas from '../../../store/malha/actions';
import Formulario from './Formulario';

const Malhas = ({ malhas, loadMalhas, deleteMalha }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [openFilter, setOpenFilter] = useState(false);

  useEffect(() => {
    loadMalhas();
  }, [loadMalhas]);

  const columns = [
    { field: 'codigo', headerName: 'Código', flex: 0.4 },
    { field: 'nome', headerName: 'Nome', flex: 1 },
  ];

  return (
    <Box>
      <Stack spacing={3}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={2}
        >
          <Typography variant="h4">Malhas</Typography>
          <Button
            variant="outlined"
            startIcon={<FilterListOutlinedIcon />}
            onClick={() => setOpenFilter(true)}
          >
            Filtros
          </Button>
        </Stack>

        <TableV2
          rows={malhas}
          columns={columns}
          onEdit={id => { setOpen(true); setId(id); }}
          onDelete={id => deleteMalha(id)}
          headerActions={[
            { label: 'Novo', onClick: () => { setOpen(true); setId(null); }, startIcon: <AddIcon />, variant: 'contained' },
          ]}
        />

        <CustomFilterV2
          variant="dialog"
          open={openFilter}
          onClose={() => setOpenFilter(false)}
          title="Filtros"
          fullWidth
          fields={[
            { field: 'useCodigo', md: 4 },
          ]}
          onFilter={filterData => {
            loadMalhas(filterData);
            setOpenFilter(false);
          }}
        />

        <Formulario
          id={id}
          open={open}
          onClose={isSave => {
            setOpen(false);
            setId(null);
            if (isSave) loadMalhas();
          }}
          malhas={malhas}
        />
      </Stack>
    </Box>
  );
};

Malhas.propTypes = {
  deleteMalha: PropTypes.func.isRequired,
  loadMalhas: PropTypes.func.isRequired,
  malhas: PropTypes.array,
};

const mapStateToProps = state => ({
  malhas: selectorsMalhas.getMalhas(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsMalhas
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Malhas));
